<template>
	<div class="tcp-page tcp-bag">
		<section class="tcp-shop__wrap">
			<h1>Shopping Cart</h1>

			<div v-if="items.length" class="tcp-bag__layout">
				<div class="tcp-bag__lines">
					<article v-for="item in items" :key="item.id" class="tcp-bag__line">
						<router-link :to="'/product/' + item.id" class="tcp-bag__photo">
							<img v-if="item.image_url" :src="item.image_url" :alt="item.name">
							<span v-else class="tcp-card__placeholder"><i class="fa fa-box"></i></span>
						</router-link>
						<div class="tcp-bag__info">
							<p v-if="item.presentation" class="tcp-shop-card__kicker">{{ item.presentation }}</p>
							<router-link :to="'/product/' + item.id">{{ item.name }}</router-link>
							<strong>{{ money(item.price) }}</strong>
							<div class="tcp-stepper">
								<div>
									<button type="button" aria-label="Decrease" @click="change(item, -1)"><i class="fa fa-minus"></i></button>
									<span>{{ item.quantity }}</span>
									<button type="button" aria-label="Increase" @click="change(item, 1)"><i class="fa fa-plus"></i></button>
								</div>
							</div>
						</div>
						<div class="tcp-bag__side">
							<button type="button" class="tcp-bag__remove" aria-label="Remove" @click="remove(item.id)"><i class="fa fa-trash-o"></i></button>
							<strong>{{ money(item.price * item.quantity) }}</strong>
						</div>
					</article>
				</div>

				<aside class="tcp-bag__summary">
					<h2>Order Summary</h2>
					<div class="tcp-summary__row">
						<span>Subtotal</span>
						<strong>{{ money(subtotal) }}</strong>
					</div>
					<div class="tcp-summary__row">
						<span>Shipping</span>
						<strong>{{ shipping === 0 ? 'Free' : money(shipping) }}</strong>
					</div>
					<div class="tcp-summary__row">
						<span>Tax</span>
						<strong>{{ money(tax) }}</strong>
					</div>
					<p class="tcp-bag__hint">Free shipping on orders over $100 USD.</p>
					<div class="tcp-summary__row tcp-summary__total">
						<span>Total</span>
						<strong>{{ money(total) }}</strong>
					</div>
					<router-link to="/checkout" class="tcp-btn">Proceed to Checkout <i class="fa fa-arrow-right"></i></router-link>
					<router-link to="/shop" class="tcp-btn tcp-btn--outline">Continue Shopping</router-link>
				</aside>
			</div>

			<div v-else class="tcp-bag__empty">
				<p>Your cart is empty.</p>
				<router-link to="/shop" class="tcp-btn">Continue Shopping</router-link>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			items: []
		}
	},
	computed: {
		subtotal() {
			return this.items.reduce((sum, item) => sum + (Number(item.price) * Number(item.quantity)), 0)
		},
		shipping() {
			if (!this.items.length || this.subtotal > 100) return 0
			return 10
		},
		tax() {
			return Math.round(this.subtotal * 0.08 * 100) / 100
		},
		total() {
			return this.subtotal + this.shipping + this.tax
		}
	},
	methods: {
		money(value) {
			return '$' + Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
		},
		refresh() {
			this.items = this.$cart.items()
		},
		change(item, step) {
			this.$cart.update(item.id, Number(item.quantity) + step)
		},
		remove(id) {
			this.$cart.remove(id)
		}
	},
	mounted() {
		this.refresh()
		this.$cartBus.$on('change', this.refresh)
	},
	beforeDestroy() {
		this.$cartBus.$off('change', this.refresh)
	}
}
</script>
